export const metodologia = 
{
  "label": "APPENDICE",
  "labelDisable": false,
  "children": [
    {
      "name": "La metodologia",
      "exact": true,
      "active": true,
      "children": [
        {
          "name": "FASE A EFRAG - Individuazione stakeholder e ambiti",
          "to": "/app/metodologia/fase-a",
          "exact": true,
          "active": true,
          "icon": "puzzle-piece"
        },
        {
          "name": "FASE B EFRAG - Individuazione rischi e loro mitigazione",
          "to": "/app/metodologia/fase-b",
          "exact": true,
          "active": true,
          "icon": "puzzle-piece"
        },
        {
          "name": "FASE C EFRAG - Valutazione rischi e azioni/opportunità per la loro mitigazione",
          "to": "/app/metodologia/fase-c",
          "exact": true,
          "active": true,
          "icon": "puzzle-piece"
        },
        {
          "name": "OUTPUT ",
          "to": "/app/metodologia/output",
          "exact": true,
          "active": true,
          "icon": "puzzle-piece"
        }
      ]
    }
  ]
}
